import React, { useCallback, useState } from 'react';
import classnames from 'classnames';
import Button from 'monday-ui-react-core/dist/Button';
import ReactQuillTextEditorComponent from '../../react-quill-text-editor/react-quill-text-editor-component';

import './quote-notes-component.scss';

export default function QuoteNotesComponent({ id, notes, onOrderDataChange, orderData, previewMode }) {
  const [notesData, setNotesData] = useState(orderData[notes.id]?.data);
  const [isNotesOpen, setIsNotesOpen] = useState(false);

  const onNotesFocus = useCallback(() => {
    setIsNotesOpen(true);
  }, [setIsNotesOpen]);

  const onNotesChange = useCallback(
    (newData) => {
      setNotesData(newData);
    },
    [setNotesData]
  );

  const onNotesSave = useCallback(() => {
    onOrderDataChange(id, { ...orderData, [notes.id]: { data: notesData, dataSource: 'html' } });
    setIsNotesOpen(false);
  }, [id, notes, orderData, notesData, onOrderDataChange]);

  const onNotesCancel = useCallback(() => {
    setNotesData(orderData[notes.id]?.data);
    setIsNotesOpen(false);
  }, [notes, orderData, setNotesData]);

  const markPdfRows = ((noteHtml) => {
    if(!noteHtml) return noteHtml;
    let noteElement = document.createElement('div');
    noteElement.innerHTML = noteHtml;
    noteElement.childNodes.forEach((child) =>{
      child.classList.add("pdf-row");
    });
    return noteElement.innerHTML;
  });

  const renderContent = () => {
    if (previewMode) {
      const noteHtml = markPdfRows(orderData[notes.id]?.data);
      return <div className="quote-notes-component-content" dangerouslySetInnerHTML={{ __html: noteHtml }} />;
    }

    return (
      <ReactQuillTextEditorComponent
        placeholder="Add notes"
        editorValue={notesData}
        onEditorValueChange={onNotesChange}
        onEditorFocus={onNotesFocus}
        hideToolbar={!isNotesOpen}
      />
    );
  };

  const renderActions = () => {
    if (previewMode || !isNotesOpen) {
      return <></>;
    }

    return (
      <div className="actions-wrapper">
        <div className="action">
          <Button size={Button.sizes.SMALL} kind={Button.kinds.TERTIARY} onClick={onNotesCancel}>
            Cancel
          </Button>
        </div>
        <div className="action">
          <Button size={Button.sizes.SMALL} onClick={onNotesSave}>
            Save
          </Button>
        </div>
      </div>
    );
  };

  return (
    <div className={classnames('quote-notes-component', { preview: previewMode })}>
      {renderContent()}
      {renderActions()}
    </div>
  );
}
